import Page from './Page';
import Component from 'vue-class-component';
import FileHandler from '../common/FileHandler';
import HeaderComponent from './Header.vue';

import template from './Checkout.vue.html';
import { CacheAsync } from '../common/Decorators/CacheAsync';
@Component({ template, components: { HeaderComponent } })
export default class Checkout extends Page {
    uploaded = {} as { [id: number]: boolean };
    pictures = {} as { [id: number]: string };

    async created() {
        return this.syncPicture();
    }

    async syncPicture(id: number = 0) {
        try {
            const r = await this.app.post('checkout-picture', {
                id,
                picture: this.pictures[id],
            });
            if (!r.succeed) throw new Error(r.error);
            this.uploaded = r.uploaded;
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(msg || 'Connection Error');

            this.app.setPage('Menu');
        }
    }

    checkoutable() {
        if (this.app.checkedout) return false;
        return Object.values(this.uploaded).every((v) => v);
    }

    @CacheAsync()
    async checkout() {
        if (!confirm(this._('checkout_confirm'))) return;
        try {
            const r = await this.app.post('checkout');
            if (r.lead) {
                alert(
                    `${this._('failed_to_checkout')}\n${this._(r.lead.content)}`
                );
                return;
            }
            if (!r.succeed) throw new Error(r.error);
            await this.app.fetchInfo();
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(msg || 'Connection Error');
        }
    }

    async uploadImage(id: number) {
        const file = await FileHandler.loadDialog({
            accept: 'image/*',
            capture: 'user',
        });
        if (!file) return;
        this.pictures[id] = await FileHandler.resizeImage(file, 2048);
        return this.syncPicture(id);
    }

    firstGuestName() {
        return (
            this.app.guestList[0].name ||
            this.app.guestList[0].name_kana ||
            this._('guest')
        );
    }

    guestNameFrom(id: number) {
        const guest = this.app.guestList.find((g) => g.id == id);

        return guest?.name || guest?.name_kana || this._('guest');
    }
}
